<template>
    <div class="carousel-user d-flex justify-content-between" :class="{'empty': !showUser}">

        <div class="user-avatar" v-if="showUser && imagePath">
            <img :src="imagePath" :alt="user.firstLine"/>
        </div>
        <p class="user-details d-flex flex-column" v-if="showUser" style="min-height: 65px">
            <span class="user-name">{{ user.firstLine }}</span>
            <span v-if="user.secondLine !== ''" class="second-line">{{ user.secondLine }}</span>
            <span v-if="user.thirdLine !== ''" class="third-line">{{ user.thirdLine }}</span>
        </p>
    </div>
</template>

<script>

    export default {
        name: 'User',

        props: {
            user: {
                type: Object,
                required: true
            },
            showUser: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            imagePath() {
                return this.user.imagePath ? this.user.imagePath : null;
            }
        }
    }
</script>
